<template>
  <router-view />
</template>

<script>
export default {
  name: "processes",
};
</script>
